//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AlgTelegramIcon',
  computed: {
    url() {
      return this.$getTextMainSetting('tg_url')
    },
  },
}
